import React, { useState, useLayoutEffect } from 'react';
import ReactPlayer from 'react-player';
import { useSelector } from 'react-redux';
import { getNavbarHeight, getViewportDimensions, keepSpaceTogether } from '../../../../models/Utils';

import './SectionIntroSlide.scss';

import Arrow from '../../../Common/Arrow/Arrow';
import AnimatedSectionTitle from '../AnimatedSectionTitle/AnimatedSectionTitle';
import SectionTitleVideo from '../SectionTitleVideo/SectionTitleVideo';
import { useMediaQuery } from 'react-responsive';

import { ADAARIARoles, ADAWidgitRoles } from '../../../../models/ADA';

const togetherString = "V Team";

const SectionIntroSlide = React.forwardRef((props, theRef) => {
  const [ heightParams, setHeightParams ] = useState({ marginTop: 0, height: 0 });
  const menuOpened = useSelector(state => state.data.menuOpened);
  const isDesktopView = useMediaQuery({ query: '(min-width: 767px)' });

  const handleResize = () => {
    const marginTop = getNavbarHeight();
    const viewport = getViewportDimensions();
    const height = viewport.height - marginTop;
    setHeightParams({
      marginTop,
      height,
    });
  };

  useLayoutEffect(() => {
    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div
      className="vbn-section-intro-slide"
      ref={theRef}
      style={{
        marginTop: `${heightParams.marginTop}px`,
        height: `${heightParams.height}px` }}
    >
      <div className="vbn-sis-wrapper cpvi-grid-container">
        <div className="cpvi-grid-row">
          <div className={`vbn-sis-text-content ${props.bigFont ? 'big' : ''} cpvi-grid-col w6`}>
            {/*
              (props.title1 && props.title1.length > 0 || props.title2 && props.title2.length > 0) &&
              <AnimatedSectionTitle title1={props.title1} title2={props.title2} />
            */}
            {
              props.videoTitleDesktop && props.videoTitleMobile && (props.title1 || props.title2) &&
              <SectionTitleVideo
                videoUrlDesktop={props.videoTitleDesktop}
                videoUrlMobile={props.videoTitleMobile}
                adaText={`${props.title1} : ${props.title2}`}
              />
            }
            {
              props.text &&
              (<React.Fragment>
                <p className="vbn-sis-text desktop">{keepSpaceTogether(props.text, togetherString)}</p>
                <p className="vbn-sis-text mobile cont-75">{keepSpaceTogether(props.text, togetherString)}</p>
              </React.Fragment>)
            }
            <div className="vbn-sis-arrow" tabIndex={0} role={ADAWidgitRoles.Button} aria-label="Scroll down to the next section" onClick={props.onGoDown}>
              <Arrow direction="down" width="10px" handleClick={props.onGoDown} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default SectionIntroSlide;
